







































import { ObjectFactory } from '@/config/objectFactory';
import { EventBus } from '@/main';
import { ToastEvent } from '@/types/event';
import { ApiRequest, UpdateQuestionnaireRequest } from '@/types/request';
import { CommonUtils } from '@/util/commonUtils';
import { MedTransGoConstants } from '@/util/constants';
import { Component, Vue } from 'vue-property-decorator';
import { required, numeric } from 'vuelidate/lib/validators';
@Component({
    props: {
        question: Object,
    },
    validations() {
        const question = this.$props.question;
        return {
            answer: {
                required,
                numeric: (question.question.startsWith('How much') ||
                question.question.startsWith('How many')) ? numeric : {},
            },
        };
    },
    data() {
        return {
            questionName: '',
            answer: '',
        };
    },
})
export default class UpdateQuestionnaireModal extends Vue {
    private show = true;
    public mounted() {
        this.show = true;
        this.$data.questionName = this.$props.question.question;
        this.$data.answer = this.$props.question.answer;
    }
    private async updateQuestionnaire() {
        const iHttpService = ObjectFactory.getHttpService();
        const updateQuestionnaireRequest: UpdateQuestionnaireRequest = {
            question: this.$data.questionName,
            answer: this.$data.answer,
        };
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/questionnaire`,
            data: updateQuestionnaireRequest,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.put<any>(apiRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: 'Questionnaire updated successfully..',
                title: 'Success!',
                timeout: 5000,
                varient: 'success',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.close();
        } else {
            CommonUtils.showError(response);
        }
    }
    private close() {
        this.$emit('close');
    }
}
